import { Component, OnInit, input } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
    selector: 'mutara-agreement',
    templateUrl: './agreement.component.html',
    styleUrls: ['./agreement.component.scss'],
    standalone: false
})
export class AgreementComponent extends FieldWrapper implements OnInit {
  readonly currentLink = input<SafeHtml | undefined>(undefined);

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    this.currentLink.apply(this.props.urlAgreement);
  }

  get debug() {
    return environment.production;
  }
  get isHidden() {
    return (<any>this.field.expressions).hide(this.field);
  }
}